import React, { useRef } from 'react';

class ComponentToPrint extends React.Component {
	state = {
		date: new Date().toLocaleString()
	};

	componentDidMount() {
		var date = new Date().toLocaleString().split(' ', 1)
		this.setState({ date});
	}
	
	render() {
		return (
			<div>
				<div className="diploma">
					<div className="pink-circle-top-right"></div>
					<div className="main-wrapper">
						<h1>DIPLOM</h1>
						<div className="underline"><h3>{this.props.user.firstname + " " + this.props.user.lastname}</h3></div>
						<p>Har tilldelats ett diplom för genomförd utbildning</p>
						<h2>{this.props.courseTitle}</h2>
						<p style={{ fontSize: "18pt" }}>Resultat: {this.props.user.results.result}</p>
						<div className="peach-square">
							<p><strong>Vid provtillfället var:</strong></p>
							<ul>
								<li>Poänginervallet för godkänt resultat: <strong>{this.props.underLimit.toFixed(2) + " - " + this.props.aboveLimit.toFixed(2)}</strong></li>
								<li>Medelvärde: <strong>{this.props.user.results.crowdAverage.average}</strong></li>
								<li>Antal personer som deltagit: <strong>{this.props.user.results.crowdAverage.amount}</strong></li>
							</ul>
						</div>
						<p style={{ textAlign: "right", marginTop: "6em", fontSize: "12pt" }}>Lärtorget {this.state.date}</p>
					</div>
					<div className="pink-circle-bottom-left"></div>
				</div>
			</div>
		);
	}
}


export default ComponentToPrint;



// WEBPACK FOOTER //
// ./src/components/Diploma.js